import React  from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import makeAnimated from "react-select/animated";
// リダイレクト(認証期間切れの場合にリダイレクトするため useHistory)
import { useParams, useHistory } from "react-router-dom";

import { get_apollo_role_path, get_apollo_roles_by_accountgroup_path }  from "../../atom/Apollo_links";
import { APOLLO_GROUP_ADMIN }  from "../../atom/Apollo_Authorization";
import { apollo_useStyles } from "../../atom/Apollo_styles";
import { ApolloContext } from "../../atom/Apollo_Context";
import { ApolloMessage } from "../../atom/Apollo_Mesasge";
import { RoleList, RoleEdit, AgEdit, AccountGroups } from "./UserModel";

import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// メッセージ定義
import {
  GetMessage,
  UI_ROLE_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

const animatedComponents = makeAnimated();

const initRoleEdit : RoleEdit = {
  value: "",
  label: "",
  authrizationId: undefined,
};

const initAgEdit : AgEdit = {
  value: "",
  label: "",
};

// @ts-ignore
const RoleSetFields = ({ roleIndex, index, removeRoles, formHooks, roleIds, accountGroups, accountGroupsSelect, setAccountGroupsSelect }) => {
  const { userid } = useParams<{userid: string}>();

  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);

  const [roleEdit, setRoleEdit] = React.useState<RoleEdit>(initRoleEdit);
  const [agEdit, setAgEdit] = React.useState<AgEdit>(initAgEdit);
  const [updateRoleId, setUpdateRoleId] = React.useState("");

  const isAuthEditable = (authrizationId?: number) => {
    if (authrizationId === undefined) {
      return true;
    } 
    const userId = state.userprofile.userId;
    if (userid !== "0" && userid === userId.toString() && authrizationId < APOLLO_GROUP_ADMIN && state.userprofile.systemAdmin !== 1) {
        return false;
    }
    return true;
  };
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  React.useEffect(()=>{
    if (userid === "0" || typeof roleIds === "undefined" || index !== roleIndex) {
      return;
    }

    var url = `${get_apollo_role_path}/${roleIds}`;
    ApolloAxios.get(url).then((response1) => {
      let result1 = response1.data.result;
      let accountGroupId = result1.accountgroupId;

      var url = `${get_apollo_roles_by_accountgroup_path}/${accountGroupId}`;

      ApolloAxios.get(url).then((response2) => {
        let a1: AgEdit = {
          value: accountGroupId,
          label: response2.data.result[0].accountgroupName,
        }
        setAgEdit(a1);

        let roleId1 = response2.data.result[0].roleId.split(",");
        let roleName1 = response2.data.result[0].roleName.split(",");

        for (var i = 0; i < roleId1.length; i++) {
          if (roleName1[i] === "D2C管理権限" ||
            roleName1[i] === "システム管理権限" ||
            roleName1[i] === "システム運用権限") {
            continue;
          }
          let r1: RoleList = {
            value: roleId1[i],
            label: roleName1[i],
          }
          roleList1.push(r1);
        }

        setChangeSelect(!changeSelect)
        setRoleList(roleList1);
        roleList1 = [];
      }).catch((err) => {
        console.log(err)

        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ROLE_EDIT,"E","0"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });

      let r1: RoleEdit = {
        value: result1.roleId,
        label: result1.name,
        authrizationId: result1.authrizationIds,
      }
      setRoleEdit(r1);
      setUpdateRoleId(result1.roleId);
    }).catch((err) => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ROLE_EDIT,"E","1"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [])

  const classes = apollo_useStyles();
  
  const fieldPrefix1 = `role_accountgroup[${roleIndex}]`;
  const fieldPrefix2 = `role_id[${roleIndex}]`;

  const [roleList, setRoleList] = React.useState<RoleList[]>([]);
  const [changeSelect, setChangeSelect] = React.useState(false);

  let roleList1: Array<RoleList> = [];

  const changeAccountGroup = (value1: any) => {
      let auth = state.current.roleAuthorization;

      setAgEdit(value1)

      let roleList1: Array<RoleList> = [];

      var url = `${get_apollo_roles_by_accountgroup_path}/${value1.value}`;

      ApolloAxios.get(url).then((response) => {
          let roleId1 = response.data.result[0].roleId.split(",");
          let roleName1 = response.data.result[0].roleName.split(",");

          for (var i = 0; i < roleId1.length; i++) {
            if (roleName1[i] === "D2C管理権限" ||
              roleName1[i] === "システム管理権限" ||
              roleName1[i] === "システム運用権限") {
              continue;
            }
            let r1: RoleList = {
              value: roleId1[i],
              label: roleName1[i],
            }
            roleList1.push(r1);
          }

          setRoleList(roleList1);

          let re: RoleEdit = {
            value: "",
            label: "",
            authrizationId: undefined,
          }
          setRoleEdit(re);
          setUpdateRoleId("");
          roleList1 = [];

          setChangeSelect(!changeSelect);

          // 選択できるアカウントグループを変更する
          updateAccountGroups();
      }).catch((err) => {
          console.log(err)

          // 認証期間切れ判定とエラーメッセージ表示
          if (!ApolloExpired(err, GetMessage("0",UI_ROLE_EDIT,"E","2"), data, setmsg, history)) {
            // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
          }
      });
  };

  const changeRoles = (value1: any) => {
    setChangeSelect(!changeSelect)
    setRoleEdit(value1);
    setUpdateRoleId(value1.value);
  };

  // 選択中のアカウントグループをオプションから除外する
  const updateAccountGroups = () => {
    // ドキュメントから選択中のアカウントグルーブを取得する
    let accountGrouops = document.querySelectorAll('[id^=role_accountgroup]');
    let accountGroupsWork:AccountGroups[] = [];
    accountGroups.forEach(function (ag1: AccountGroups) {
      let flag = false;
      accountGrouops.forEach(function (ag2: any) {
        // アカウントグループオプションのアカウントグループID(数値)と選択中のアカウントグループID(文字)を比較
        if (ag1.value + "" === ag2?.className) {
          flag = true;
        }
      })
      if (!flag) {
        // 未選択のアカウントグループを追加する
        accountGroupsWork.push(ag1);
      }
    })
    setAccountGroupsSelect(accountGroupsWork);
  }
  
  return (
    <Grid item xs={12}>
      <ListItem className={classes.listItem} >
        <Grid container spacing={1}>
          <Grid item xs={1}>
            <Button type="button"
              variant="contained"
              color="secondary"
              disabled={!isAuthEditable(roleEdit.authrizationId)}
              onClick={removeRoles(roleIndex)}>
              削除
            </Button>
          </Grid>
          <Grid item xs={6}>
            <div id={`${fieldPrefix1}`} className={`${agEdit.value}`}></div>
            <Controller
              id={`${fieldPrefix1}`}
              name={`${fieldPrefix1}`}
              render={({ onChange }) => (
                <Select
                  placeholder="アカウントグループ名"
                  onChange={(e) => {
                    onChange(e)
                    changeAccountGroup(e)
                  }}
                  options={accountGroupsSelect}
                  key={changeSelect ? "Loading" : "Loaded"}
                  value={agEdit}
                  isDisabled={!isAuthEditable(roleEdit.authrizationId)}
                />
              )}
              control={formHooks.control}
              components={animatedComponents}
            />
          </Grid>
          <Grid item xs={5}>
            <div id={`${fieldPrefix2}`} className={`${updateRoleId}`}></div>
            <Controller
              id={`${fieldPrefix2}`}
              name={`${fieldPrefix2}`}
              render={({ onChange }) => (
                <Select
                  placeholder="ロール名"
                  onChange={(e) => {
                    onChange(e)
                    changeRoles(e)
                  }}
                  options={roleList}
                  key={changeSelect ? "Loading" : "Loaded"}
                  value={roleEdit}
                  isDisabled={!isAuthEditable(roleEdit.authrizationId)}
                />
              )}
              control={formHooks.control}
              components={animatedComponents}
            />
          </Grid>
        </Grid>
      </ListItem>
    </Grid>
  );
};

// @ts-ignore
export const RoleSetGroup = ({ roleIndexes, addRoles, removeRoles, formHooks, roleIds, accountGroups, accountGroupsSelect, setAccountGroupsSelect }) => (
  <form>
    <Button type="button"
      variant="contained"
      color="primary"
      onClick={addRoles}>
      ロール追加
    </Button>
    <List disablePadding>
      {
        roleIndexes ? roleIndexes.map((roleIndex: string | number | null | undefined, index: any) =>
          <RoleSetFields
            key={roleIndex}
            roleIndex={roleIndex}
            index={index+1}
            removeRoles={removeRoles}
            accountGroups={accountGroups}
            accountGroupsSelect={accountGroupsSelect}
            setAccountGroupsSelect={setAccountGroupsSelect}
            formHooks={formHooks}
            roleIds={roleIds[index-1]}
          />
        ) : ""
      }
    </List>
  </form>
);
